// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1hS55","legacyBtn":"MutateMid_legacyBtn__3fcsB"};